'use strict';

angular.module('mobile-apps').controller('TutorialController', [
	'$scope',
	'ConfigData',
	function (
		$scope,
		ConfigData,
	) {
		$scope.webUrl = ConfigData.applanga.website;		
	}
]);


